import React from "react";
import {AdAssetProcessType} from "./common/AdAssetModel";
import AdAssetsEdit from "./AdAssetsEdit";
import GenericTemplate from "../../../templates/GenericTemplate";
import {useParams} from "react-router-dom";
import {ApolloBreadcrumbs2, BreadcrumbsData} from "../../../atom/Apollo_Breadcrumbs2";
import {CustomizedSnackbars} from "../../../atom/Apollo_Mesasge";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission} from "../../../atom/Apollo_Authorization";

const AdAssetsCreate: React.FC = () => {

    const {accountgroupid, accountid, platformaccountid} = useParams();
    const breadcrumbsData: BreadcrumbsData = {
        categoryId: 16,
        breadId: 2,
        queries: [],
        menu: {
            id: 2,
            accountId: platformaccountid,
            accountName: "",
        },
        campaign: null,
        adgroup: null,
        advertisement: null,
        asset: null,
    }

    return (

        <GenericTemplate title="">
            <CustomizedSnackbars/>
            <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
                <ApolloBreadcrumbs2 data={breadcrumbsData}/>
                <AdAssetsEdit accountGrpId={accountgroupid} accountId={accountid} processType={AdAssetProcessType.create}
                            platformaccountid={platformaccountid} assetId={0}/>
            </ApolloPageUsagePermission>
        </GenericTemplate>
    )
}

export default AdAssetsCreate;
